export const schedule = [
  {
    path: '/schedule',
    component: () => import(/* webpackChunkName: "schedule" */ '@/views/schedule/Schedule'),
    children: [
      {
        path: 'horizontal',
        component: () => import(/* webpackChunkName: "schedule" */ '@/views/schedule/components/ScheduleHorizontal'),
      },
      {
        path: 'vertical',
        component: () => import(/* webpackChunkName: "schedule" */ '@/views/schedule/components/ScheduleVertical'),
      },
    ],
    redirect: '/schedule/horizontal',
  },
]
